import { MDCCheckbox } from '@material/checkbox';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/form-fields/checkbox-field.scss';

Component('tr-checkbox-field', {
  mixins: [eventListenerMixin],

  properties: {
    checked: {
      type: Boolean,
      default: false,
      observer() {
        this.checkedChanged();
      },
    },

    indeterminate: {
      type: Boolean,
      default: false,
      observer() {
        this.indeterminateChanged();
      },
    },

    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.mdcCheckbox.disabled = this.disabled;
      },
    },

    asyncInit: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    if (this.asyncInit) {
      setTimeout(() => {
        this.init();
      });
    } else {
      this.init();
    }
  },

  init() {
    this.nativeField = this.querySelector('input[type="checkbox"]');
    this.mdcCheckbox = new MDCCheckbox(this.querySelector('.mdc-checkbox'));
    if (this.checked) {
      this.mdcCheckbox.checked = this.checked;
    } else if (this.indeterminate) {
      this.mdcCheckbox.indeterminate = this.indeterminate;
    }

    this.listenTo(this.nativeField, {
      change: this.handleCheckboxChanged.bind(this),
    });
  },

  disconnected() {
    if (this.mdcCheckbox) this.mdcCheckbox.destroy();
    this.stopListening();
  },

  getValue() {
    return this.mdcCheckbox.value;
  },

  handleCheckboxChanged(event) {
    const { checked, value } = event.target;
    if (this.checked === checked) return;

    this.checked = checked;
    this.namespacedTrigger('change', {
      detail: { checked, value },
      bubbles: true,
    });
  },

  checkedChanged() {
    this.mdcCheckbox.checked = this.checked;
  },

  indeterminateChanged() {
    this.mdcCheckbox.indeterminate = this.indeterminate;
  },
});
